export default {
    'chatInput.connectionProblems': 'Problem mit der Internetverbindung.',
    'chatInput.reconnecting': 'Wiederverbindung ...',
    'chatInput.duplicateMessage': 'Sie können dieselbe Nachricht nicht zweimal hintereinander senden.',
    'chatInput.chatAttachment.uploadFileError': 'Beim senden der datei ist ein fehler aufgetreten!',
    'chatInput.chatAttachment.fileSizeError': 'Es ist nicht möglich, dateien mit mehr als 15 MB hochzuladen!',
    'chatInput.chatAttachment.maxFilesError': 'Es ist nicht möglich, mehr als 5 Dateien gleichzeitig hochzuladen',
    'chatInput.chatAttachment.sameFileError': 'Es ist nicht möglich, dieselbe datei erneut hochzuladen!',
    'chatInput.autoComplete.edit': 'Antwort bearbeiten',
    'chatInput.autoComplete.send': 'Senden sie intent',
    'chatInputField.chatInputPlaceholder': 'Frag mich etwas...',
    'chatInputField.chatInputPlaceholderAgentMode': 'Schreiben Sie hier an den Benutzer ...',
    'chatInputField.chatInputPlaceholderFileUploadMode': 'Schreiben Sie, was mit dem Inhalt der Datei gemacht werden soll.',
    'chatInputField.suggestionInputPlaceholder': 'Wählen Sie eine der Optionen ...',
    'speechBubble.dateTime.today' : 'Heute',
    'speechBubble.dateTime.at' : 'um',
    'infoPage.privacyPolicyLinkText': 'Datenschutz-Bestimmungen',
    'infoPage.goBackButtonText': 'Zurück',
    "chatInput..title.send": "Nachricht senden",
    "topBar.title.help": "Info",
    "topBar.title.mini": "Minimieren/Maximieren",
    "topBar.title.close": "Chat schließen"
}
